export default __webpack_public_path__ + "static/Security-8606df9d466b5169007c86f054bd9f66.gif";